var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',[_c('div',{staticClass:"room-legend"},_vm._l((_vm.rooms),function(room){return _c('v-chip',{key:room.id,staticClass:"white--text",attrs:{"color":room.color}},[_vm._v("\n      "+_vm._s(room.title))])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }